import classNames from 'classnames';
import React from 'react';
import ReactSelect, { components } from 'react-select';
import { FormGroupLabel } from '../common/FormGroupLabel';
import Icon from '../../icon/Icon';
import { acChevronDown, acClose } from 'ac-icon';
import { filterOptionSelector, isEmpty } from 'ac-share';
const Select = ({ id, name, label, value, options, valid, feedback, required, disabled, onChange, className, placeholder, helpText, noOptionsMessage, isClearable, isSearchInvertLayout, optionsWithIcons, isSearchable = true, feedbackClassName, menuPosition = 'absolute', isShowRequired, }) => {
    const getSelectedValue = (v) => {
        if (v) {
            if (options) {
                return options.find((o) => o.value === v);
            }
        }
        else {
            return undefined;
        }
    };
    const DropdownIndicator = (props) => {
        return (React.createElement(components.DropdownIndicator, Object.assign({}, props, { className: 'pr-0' }),
            React.createElement(Icon, { path: acChevronDown, size: '20px', title: undefined })));
    };
    const ClearIndicator = (props) => {
        return (React.createElement(components.DropdownIndicator, Object.assign({}, props),
            React.createElement(Icon, { path: acClose, size: '20px', title: 'Очистить' })));
    };
    const Option = (props) => (React.createElement(components.Option, Object.assign({}, props),
        React.createElement("div", { className: 'd-flex flex-row align-items-center' },
            props.data.icon && React.createElement("div", { className: 'd-flex mr-x2' }, props.data.icon),
            props.data.label)));
    const SingleValue = (props) => (React.createElement(components.SingleValue, Object.assign({}, props),
        React.createElement("div", { className: 'd-flex flex-row align-items-center' },
            props.data.icon && React.createElement("div", { className: 'select-single-value-icon d-flex mr-x2' }, props.data.icon),
            React.createElement("span", { className: 'w-100' }, props.data.label))));
    const css = classNames('ac-select ', {
        disabled: disabled,
    });
    return (React.createElement(FormGroupLabel, { label: label, valid: valid, feedback: feedback, className: className, isShowRequired: !isEmpty(isShowRequired) ? isShowRequired : required, helpText: helpText, feedbackClassName: feedbackClassName },
        React.createElement(ReactSelect, { id: id, name: name, value: getSelectedValue(value), className: css, options: options, noOptionsMessage: () => {
                return noOptionsMessage ? noOptionsMessage : 'Ничего не найдено';
            }, placeholder: placeholder ? placeholder : 'Выбрать…', classNamePrefix: 'ac-input-select', required: required, isDisabled: disabled, isClearable: isClearable, isSearchable: isSearchable, filterOption: isSearchInvertLayout ? filterOptionSelector : undefined, onChange: (selected) => {
                onChange(selected ? selected.value : undefined);
            }, menuPosition: menuPosition, components: optionsWithIcons
                ? {
                    SingleValue,
                    Option,
                    DropdownIndicator,
                    ClearIndicator,
                }
                : {
                    DropdownIndicator,
                    ClearIndicator,
                } })));
};
export { Select };
//# sourceMappingURL=Select.js.map